import {useState, useRef, useEffect, useContext} from "react";
import {useTranslation} from "react-i18next";
import {SwalAlertClass} from "core/swalClass";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import axiApi from "ApiCaller";
import {OrganizationModel, ContactData} from "site-apps/authuser/OrganizationModels";
import {PanelModel} from "site-apps/authuser/PanelModel";
import ImageChooser from "components/ImageChooser";
import FormPanel from "./FormPanel";
import FormButton from "components/buttons/FormButton";
import AuthContext from "context/AuthContext";
import MapManagerModal from "components/maps/MapManagerModal";
import MapBase from "components/maps/MapBase";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";
import MapAssetContainer from "site-apps/assets/MapAssetContainer";

const FormOrganization = ({item}) => {
    const {t} = useTranslation("forms");
    const {user, panel, updatePanel} = useContext(AuthContext);
    const [formData, setFormData] = useState({...OrganizationModel});
    const panels = useRef([]);
    const [panChoose, setPanChoose] = useState({...PanelModel});
    const [showCanvas, setShowCanvas] = useState(false);
    const [showMapModal, setShowMapModal] = useState(false);
    const Alert = new SwalAlertClass({confirmButtonText: t("labels.accept")});
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = (e) => {
        setIsLoading(true);
        e.preventDefault();
        let form = e.target.closest("form");
        let data = new FormData(form);
        axiApi
            .post("/api/organization/", data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((r) => {
                if (r.data.status) {
                    Alert.success(t("success.title"), t("success.title"));
                } else {
                    Alert.warning(t("labels.error"), r.data.message);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.error(error);
                Alert.error(t("errors.title"), t("errors.server-error"));
            });
    };
    const onClickPanel = (e) => {
        let idx = parseInt(e.target.dataset.idx);
        let choose = {...panels.current[idx]};
        choose.idx = idx;
        setPanChoose(choose);
        setShowCanvas(true);
    };
    const updateCurrentPanel = (panel_, idx) => {
        panels.current[idx] = panel_;
        if (panel.token === panel_.token) {
            updatePanel(panel_);
        }
    };

    const handleModalMap = () => {
        setShowMapModal(true);
    };

    const handleChange = (event) => {
        const {name, value} = event.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    useEffect(() => {
        let org = {...item, ContactData};
        if (item.contact) {
            org.person = org.contact.person ? org.contact.person : "";
            org.charge = org.contact.charge ? org.contact.charge : "";
            org.email = org.contact.email ? org.contact.email : "";
            org.phone = org.contact.phone ? org.contact.phone : "";
        }
        panels.current = item.panels;
        setFormData(org);
    }, []);

    useEffect(() => {
        const handlePositionSelected = (e) => {
            const {lat, lng} = e.detail;
            setFormData((prev) => ({
                ...prev,
                lat: lat.toFixed(6),
                lng: lng.toFixed(6),
            }));
        };

        subscribeEvent("mapmodal:position:selected", handlePositionSelected);

        return () => {
            unsubscribeEvent("mapmodal:position:selected", handlePositionSelected);
        };
    }, []);

    return (
        <div className="container-fluid">
            <div className="col-12">
                <Form className="row pb-5" onSubmit={onSubmit} encType="multipart/form-data">
                    <input type="hidden" name="token" value={item.token} />
                    <div className="col-md-4">
                        <h5 className="mb-0 text-primary">{t("organization.title", "Organización")}</h5>
                        <hr className="mt-0" />
                        <div className="row mt-4">
                            <div className="col-12 text-center">
                                <ImageChooser name={"ilogo-" + item.token} image={item.ilogo ? "/media/" + item.ilogo : null} />
                            </div>
                        </div>
                        item
                        <div className="row mt-4">
                            <div className="col-md-4 d-flex align-items-center justify-content-end">
                                <label>{t("common.name")}:</label>
                            </div>
                            <div className="col-md-8">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name="name"
                                    required
                                    defaultValue={item.name}
                                />
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-md-4 d-flex align-items-center justify-content-end">
                                <label>{t("common.description")}:</label>
                            </div>
                            <div className="col-md-8">
                                <textarea
                                    className="form-control"
                                    id="description"
                                    name="description"
                                    defaultValue={item.description}
                                />
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-md-4 d-flex align-items-center justify-content-end">
                                <label>{t("organization.address", "Dirección")}:</label>
                            </div>
                            <div className="col-md-8">
                                <textarea
                                    className="form-control"
                                    id="full_address"
                                    name="full_address"
                                    defaultValue={item.full_address}
                                />
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-md-4 d-flex align-items-center justify-content-end">
                                <label>{t("organization.timezone", "Timezone")}:</label>
                            </div>
                            <div className="col-md-8">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="timezone"
                                    name="timezone"
                                    required
                                    defaultValue={item.timezone}
                                />
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-md-4 d-flex align-items-center justify-content-end">
                                <label>{t("plugin.client")}:</label>
                            </div>
                            <div className="col-md-8">{item.client}</div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-1"></div>
                            <div className="col-11 card pb-3">
                                <div className="row">
                                    <div className="col-1"></div>
                                    <div className="mt-2 col-4">
                                        <label htmlFor="lat" className="form-label">
                                            {t("common.latitude")}
                                        </label>
                                        <input
                                            type="number"
                                            max="90"
                                            min="-90"
                                            className="form-control"
                                            id="lat"
                                            name="lat"
                                            step="any"
                                            value={formData.lat}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mt-2 col-4">
                                        <label htmlFor="lng" className="form-label">
                                            {t("common.longitude")}
                                        </label>
                                        <input
                                            type="number"
                                            max="90"
                                            min="-90"
                                            step="any"
                                            className="form-control"
                                            id="lng"
                                            name="lng"
                                            value={formData.lng}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-1"></div>
                                    <div className="mt-3 pt-4 col-2">
                                        <Button
                                            title="Editar ubicación"
                                            variant="btn btn-outline-primary"
                                            type="button"
                                            onClick={handleModalMap}>
                                            <FontAwesomeIcon icon="fa-map-location-dot" />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <h5 className="mb-0 text-primary">{t("organization.contact", "Contacto")}</h5>
                        <hr className="mt-0" />
                        <div className="row mt-4">
                            <div className="col-md-4 d-flex align-items-center justify-content-end">
                                <label>{t("organization.contactPerson", "Contacto")}:</label>
                            </div>
                            <div className="col-md-8">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="person"
                                    name="person"
                                    defaultValue={formData.person}
                                />
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-md-4 d-flex align-items-center justify-content-end">
                                <label>{t("organization.position", "Cargo")}:</label>
                            </div>
                            <div className="col-md-8">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="charge"
                                    name="charge"
                                    defaultValue={formData.charge}
                                />
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-md-4 d-flex align-items-center justify-content-end">
                                <label>{t("organization.email", "Email")}:</label>
                            </div>
                            <div className="col-md-8">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="email"
                                    name="email"
                                    defaultValue={formData.email}
                                />
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-md-4 d-flex align-items-center justify-content-end">
                                <label>{t("organization.phone", "Telefono")}:</label>
                            </div>
                            <div className="col-md-8">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="phone"
                                    name="phone"
                                    defaultValue={formData.phone}
                                />
                            </div>
                        </div>

                        {formData && formData.lat && formData.lng && (
                            <div className="mt-5">
                                <MapAssetContainer coords={[formData.lat, formData.lng]} />
                            </div>
                        )}
                    </div>
                    <div className="col-md-4">
                        <div className="mb-4">
                            <h5 className="mb-0 text-primary">{t("organization.concessions", "Concesiones")}</h5>
                            <hr className="mt-0" />
                            <div
                                className=""
                                style={{
                                    // maxHeight: "300px",
                                    minHeight: "200px",
                                }}>
                                {formData.panels.map((mun, idx) => (
                                    <div className="m-1" key={idx}>
                                        <button type="button" className="btn btn-link p-1" data-idx={idx} onClick={onClickPanel}>
                                            {mun.name}
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div>
                            <h5 className="mb-0 text-primary">{t("organization.users", "Usuarios")}</h5>
                            <hr className="mt-0" />
                            <div
                                className=""
                                style={{
                                    // maxHeight: "300px",
                                    minHeight: "300px",
                                }}>
                                <div className="ps-2">
                                    {formData.users.map((email, idx) => (
                                        <p className="m-1" key={idx}>
                                            {email}
                                        </p>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-end pb-3 col-12 fixed-bottom">
                        {user.is_superuser ? (
                            <FormButton
                                label={t("labels.save")}
                                type="submit"
                                className="btn btn-primary"
                                isProcessing={isLoading}>
                                {t("labels.save")}
                            </FormButton>
                        ) : (
                            <></>
                        )}
                    </div>
                </Form>
                <FormPanel showCanvas={showCanvas} setShowCanvas={setShowCanvas} item={panChoose} update={updateCurrentPanel} />
                <MapManagerModal
                    provider={panels.current.map_type}
                    show={showMapModal}
                    setShow={setShowMapModal}
                    title={"Organización"}
                    initialLat={formData.lat}
                    initialLng={formData.lng}
                />
            </div>
        </div>
    );
};

export default FormOrganization;
